import { PocBackdrop, PocProgressSpinner, PocSkeletonLoader } from 'commons/components/components-wrapper';
import {
    SkeletonLoaderMainContent,
    SkeletonLoaderMenu,
    SkeletonNoLoginContentLayout,
    SkeletonNoLoginHeaderLayout,
    SkeletonNoLoginLayout,
} from './skeleton-no-login.style';

export const SkeletonNoLoginComponent: React.FC = () => (
    <>
        <PocBackdrop disableScrollLock opacity={0.5}>
            <PocProgressSpinner data-testid="skeleton-no-login-spinner" variant="secondary" size="xxLarge" />
        </PocBackdrop>
        <SkeletonNoLoginLayout>
            <SkeletonNoLoginHeaderLayout>
                <PocSkeletonLoader data-testid="skeleton-no-login-loader" animation />
            </SkeletonNoLoginHeaderLayout>
            <SkeletonNoLoginContentLayout>
                <SkeletonLoaderMenu className="menu" animation />
                <SkeletonLoaderMainContent className="main-content" animation />
            </SkeletonNoLoginContentLayout>
        </SkeletonNoLoginLayout>
    </>
);
